import { render, staticRenderFns } from "./AllReport.vue?vue&type=template&id=47b4843d&scoped=true"
import script from "./AllReport.vue?vue&type=script&lang=js"
export * from "./AllReport.vue?vue&type=script&lang=js"
import style0 from "./AllReport.vue?vue&type=style&index=0&id=47b4843d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4843d",
  null
  
)

export default component.exports